// /src/components/Sliderupdate.jsx
import React, { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import Sidebar from "./Sidebar";
import Swal from "sweetalert2";
import { getSliders, createSlider, updateSlider, deleteSlider } from "../api/auth/authService";

function Sliderupdate() {
  const [values, setValues] = useState({
    image: null,
    title: "",
  });
  const [portfolioData, setPortfolioData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const fetchPortfolioData = async () => {
      try {
        const response = await getSliders(); // Assuming getTestimonials is repurposed for /api/public/slider
        setPortfolioData(response);
      } catch (error) {
        console.error("Error fetching slider data:", error);
        Swal.fire("Error", "Failed to fetch slider data.", "error");
      }
    };
    fetchPortfolioData();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setValues((prev) => ({ ...prev, image: files[0] }));
    } else {
      setValues((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    const currentDate = new Date().toISOString().split("T")[0];

    if (values.image) {
      formData.append("image", values.image);
    }
    formData.append("title", values.title);
    formData.append("date", currentDate);

    try {
      if (isEdit && editId !== null) {
        await updateSlider(editId, formData);
        Swal.fire("Success!", "Slider updated successfully!", "success");
      } else {
        const response = await createSlider(formData);
        setPortfolioData([...portfolioData, response]);
        Swal.fire("Success!", "Slider added successfully!", "success");
      }

      // Reset form
      setValues({ image: null, title: "" });
      setIsEdit(false);
      setEditId(null);

      // Refresh list
      const refreshedData = await getSliders();
      setPortfolioData(refreshedData);
    } catch (error) {
      console.error("Error saving slider:", error);
      Swal.fire("Error", "Failed to save slider item.", "error");
    }
  };

  const handleEdit = (item) => {
    setValues({
      image: null, // Only upload new image if needed
      title: item.title,
    });
    setIsEdit(true);
    setEditId(item.id);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the slider item.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteSlider(id);
          setPortfolioData(portfolioData.filter((item) => item.id !== id));
          Swal.fire("Deleted!", "Slider has been deleted.", "success");
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error", "Failed to delete slider item.", "error");
        }
      }
    });
  };

  return (
    <div>
      <Sidebar />
      <div className="col-md-9 px-0" style={{ marginLeft: "250px" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h5 className="page-title">Slider Update</h5>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-8">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="sliderImage" className="form-label">
                    Slider Image
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="sliderImage"
                    accept="image/*"
                    name="image"
                    onChange={handleChange}
                    required={!isEdit}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="sliderTitle" className="form-label">
                    Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="sliderTitle"
                    placeholder="Enter Title"
                    name="title"
                    value={values.title}
                    onChange={handleChange}
                    required={!isEdit}
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  {isEdit ? "Update Slider" : "Add Slider"}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Slider Table */}
        <div className="col-md-12 mt-5">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Slider Image</th>
                <th>Title</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {portfolioData.length > 0 ? (
                portfolioData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={
                          item.imageBytes
                            ? `data:image/jpeg;base64,${item.imageBytes}`
                            : "https://via.placeholder.com/100"
                        }
                        alt="Slider"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </td>
                    <td>{item.title}</td>
                    <td>{item.date}</td>
                    <td>
                      <button
                        className="btn btn-primary me-2"
                        onClick={() => handleEdit(item)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No sliders found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Sliderupdate;